<template lang="pug">
shListData(title="Precios" resolver="prices" keyData="price" component="shPrice")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Prices',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/price/Prices.vue